import { Helmet } from 'react-helmet-async';
import React from 'react';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import OrgSurveySettingsFormContainer from '../../../../containers/organizations/Settings/OrgSurveyFormContainer.jsx';

const SurveySettings = ({ slug }) => (
  <>
    <Helmet>
      <title>Add Feedback Form Template | ChangeSync</title>
    </Helmet>
    <OrgSurveySettingsFormContainer slug={slug} />
  </>
);

SurveySettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(SurveySettings));
